<template>
  <div>
    <file-input-modal
        v-if="modalUpload"
        v-model="modalUpload"
        titulo="Envie sua foto"
        titulo-btn="Importar foto"
        content-type="image/png, image/jpeg"
        @selecionarArquivo="realizarUploadFoto"
        @modalInputFechar="fecharModalUpload"
    />
    <v-dialog
        v-model="model"
        scrollable
        @click:outside="fecharModal"
        :persistent="persistencia"
        :max-width="maxWidth"
        style="padding: 0">
      <v-card class="card-component">
        <v-toolbar dark color="primary" elevation="0">
          <v-toolbar-title>Selecionar avatar
          </v-toolbar-title>
          <v-spacer/>
          <v-btn class="close__button" text @click="fecharModal" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row class="container-avatares">
            <div v-for="avatar in avatarList" :key="avatar.id" @click="selecionarAvatar(avatar)">
              <v-col cols="12" class="container-avatar-item">
                <div v-if="avatar.isRealizarUpload" @click="abrirModalUpload">
                  <div class="container-upload-foto imagem-avatar" v-if="!avatar.uri">
                    <v-icon size="30">add_a_photo</v-icon>
                  </div>
                  <v-img v-else :src="createUrl(avatar.uri)" :class="ehFotoSelecionada(avatar)" class="upload-nova-foto"
                         aspect-ratio="4/3" alt="Selecionar nova foto">
                    <v-icon size="50">add_a_photo</v-icon>
                  </v-img>
                </div>
                <foto-avatar v-else :foto-url="avatar.uri" :class-avatar="ehFotoSelecionada(avatar)"/>
              </v-col>
            </div>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-3">
          <v-spacer/>
          <v-btn @click="atualizarFoto" outlined>Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {actionTypes} from '@/core/constants'
import {mapGetters} from 'vuex'
import FotoAvatar from '@/views/components/FotoAvatar.vue'
import FileInputModal from '@/views/components/FileInputModal.vue'

export default {
    name: 'avatarSeletor',
    components: {FileInputModal, FotoAvatar},
    props: {
        value: {
            type: Boolean,
            required: true
        },
        persistencia: {
            type: Boolean,
            default: false
        },
        maxWidth: {
            type: Number,
            default: 450
        }
    },
    data() {
        return {
            avatarList: [],
            fotoSelecionada: null,
            modalUpload: false,
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    async mounted() {
        await this.buscarAvatares()
    },
    methods: {
        ...mapGetters([
            'getUsuarioLogado'
        ]),
        async buscarAvatares() {
            const resposta = await this.$store.dispatch(actionTypes.USUARIO.BUSCAR_AVATARES)
            if (resposta) {
                this.avatarList = resposta.items
            }
            this.setarFotoAvatar()
        },
        setarFotoAvatar() {
            const fotoPadrao = this.avatarList.find(avatar => avatar.uri === this.getUsuarioLogado().foto)
            if (fotoPadrao) {
                this.fotoSelecionada = fotoPadrao
            }
        },
        async realizarUploadFoto(arquivo) {
            const input = {
                arquivo: arquivo
            }
            this.setMensagemLoading('Realizando upload...')
            await this.$store.dispatch(actionTypes.USUARIO.ATUALIZAR_FOTO_AVATAR, input)
            await this.$store.dispatch(actionTypes.COMUM.BUSCAR_DADOS_USUARIO_AUTENTICADO)
            this.mostrarNotificacaoSucesso('Upload realizado com sucesso!')
            await this.buscarAvatares()
            this.fecharModalUpload()
        },
        async atualizarFoto() {
            if (!this.fotoSelecionada) {
                this.mostrarNotificacaoErro('Selecione uma foto!')
                return
            }
            const input = {
                uriAvatar: this.fotoSelecionada.uri
            }
            this.setMensagemLoading('Selecionando avatar...')
            await this.$store.dispatch(actionTypes.USUARIO.SELECIONAR_FOTO_AVATAR, input)
            await this.$store.dispatch(actionTypes.COMUM.BUSCAR_DADOS_USUARIO_AUTENTICADO)
            this.mostrarNotificacaoSucesso('Avatar atualizado com sucesso!')
            this.fecharModal()
        },
        selecionarAvatar(foto) {
            this.fotoSelecionada = foto
        },
        fecharModal() {
            this.model = false
            this.$emit('modalAvatarSeletorAcaoFechar')
        },
        ehFotoSelecionada(foto) {
            if (!this.fotoSelecionada) return 'imagem-avatar'
            if (foto.id === this.fotoSelecionada.id) {
                return 'foto-selecionada'
            }
            return 'imagem-avatar'
        },
        abrirModalUpload() {
            this.modalUpload = true
        },
        fecharModalUpload() {
            this.modalUpload = false
        },
    }
}
</script>

<style scoped lang="stylus">

.container-avatares
  margin-top 10px
  padding 5px
  height 250px
  overflow-y auto

.container-avatar-item
  padding 5px

.container-upload-foto
  display flex
  justify-content center

.container-upload-foto:hover
  background-color #a1a1a1

.upload-nova-foto
  display flex
  align-items center
  text-align center

.upload-nova-foto >>> .v-icon
  color rgba(255, 255, 255, 0.5)

.upload-nova-foto:hover >>> .v-icon
  color white

.imagem-avatar, .foto-selecionada
  height 90px
  width 90px
  border 2px solid #eee

.imagem-avatar:hover, .foto-selecionada:hover
  cursor pointer
  border 2px solid #00bcd4

.foto-selecionada
  border 2px solid lawngreen

</style>